import { AllAppEvents, AppEvent, TrackedEventName } from "@ac-expo/api-types";

export const getAppEventMessage = <
  TName extends TrackedEventName,
  TData extends Extract<AllAppEvents, { name: TName }>["data"],
>(
  name: TName,
  data: TData
): AppEvent<TName, TData> => ({
  name,
  data,
});
